import React from "react";
import { Grid, TextField, Button } from "material-ui";
import OP from "./op.png";
import Aktia from "./aktia.png";
import Alandsbanken from "./alands.png";
import SPankki from "./spankki.png";
import Nordea from "./nordea.png";
import Pop from "./pop.png";
import Danske from "./danskebank.png";
import OmaSP from "./omasp.png";
import SP from "./sp.png";
import Mobiilivarmenne from "./mobiilivarmenne.png";
import { IEIdentifyProvider } from "ducks/eidentify";

interface Common {
    id?: string;
    style?: React.CSSProperties;
    className?: string;
    label?: string;
}

interface IProps {
    providerData: IEIdentifyProvider[] | null;
    handleClick: (id: number) => void;
}

const getImage = (id: number) => {
    switch (id) {
        case 1:
            return Nordea;
        case 2:
            return OP;
        case 3:
            return Aktia;
        case 5:
            return SPankki;
        case 6:
            return Pop;
        case 7:
            return Danske;
        case 8:
            return Alandsbanken;
        case 9:
            return OmaSP;
        case 10:
            return SP;
        case 11:
            return Mobiilivarmenne;
        default:
            return OP;
    }
};

export const Banks: React.SFC<IProps> = (props) => {
    const { providerData } = props;

    return (
        <div>
            <Grid container spacing={0}>
                {providerData &&
                    providerData.map((el: IEIdentifyProvider) => {
                        return (
                            <Grid item xs={4} sm={4} key={el.id}>
                                <div>
                                    <div className="bankBox">
                                        <div
                                            className="bankImage"
                                            onClick={() =>
                                                props.handleClick(el.id)
                                            }
                                        >
                                            <input
                                                type="image"
                                                src={getImage(el.id)}
                                                alt={el.name}
                                            />
                                        </div>
                                        <div className="bankName">
                                            <p>{el.name}</p>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        );
                    })}
            </Grid>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/views/eidentify/components/Banks/Banks.tsx